function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var Saito = require('saito-js/saito')["default"];
var _require = require('./supply'),
  handleRequestSupply = _require.handleRequestSupply;
var _require2 = require('./address'),
  handleRequestAddress = _require2.handleRequestAddress;
var _require3 = require('./response'),
  requestParams = _require3.requestParams,
  success = _require3.success,
  failure = _require3.failure;
function addBlockStatus(obj, block) {
  try {
    if (block.inLongestChain != null) {
      obj.in_longest_chain = Boolean(block.inLongestChain);
    }
  } catch (err) {
    // Keep the serialized value when the wrapper cannot expose this status.
  }
  try {
    if (block.hasGoldenTicket != null) {
      obj.has_golden_ticket = Boolean(block.hasGoldenTicket);
    }
  } catch (err) {
    // Keep the serialized value when the wrapper cannot expose this status.
  }
  return obj;
}
function blockToJson(block) {
  var obj = addBlockStatus(JSON.parse(block.toJson()), block);
  obj.transactions = (block.transactions || []).map(function (tx) {
    var txjson = tx.toJson();
    txjson.msg = tx.returnMessage();
    return txjson;
  });
  return obj;
}
function blockHeaderToJson(block) {
  var obj = addBlockStatus(JSON.parse(block.toJson()), block);
  obj.transactions = [];
  return obj;
}
function handleRequestBlocks(_x, _x2) {
  return _handleRequestBlocks.apply(this, arguments);
}
function _handleRequestBlocks() {
  _handleRequestBlocks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, txmsg) {
    var _params$count, _params$include_offch;
    var params, count, includeOffchain, beforeId, results, id, hashes, i, block, _block, blocks, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          params = requestParams(txmsg);
          count = Math.min(Number((_params$count = params.count) !== null && _params$count !== void 0 ? _params$count : 20), 50);
          includeOffchain = Boolean((_params$include_offch = params.include_offchain) !== null && _params$include_offch !== void 0 ? _params$include_offch : false);
          beforeId = params.before_id != null ? Number(params.before_id) : null;
          if (!(!Number.isFinite(count) || count <= 0)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, failure('invalid count'));
        case 1:
          if (!(beforeId != null && Number.isFinite(beforeId) && beforeId > 0)) {
            _context.n = 15;
            break;
          }
          results = [];
          id = beforeId - 1;
        case 2:
          if (!(id > 0 && results.length < count)) {
            _context.n = 14;
            break;
          }
          _context.p = 3;
          if (!includeOffchain) {
            _context.n = 9;
            break;
          }
          _context.n = 4;
          return app.core.blockchain.getHashesAtId(BigInt(id));
        case 4:
          hashes = _context.v;
          i = 0;
        case 5:
          if (!(i < hashes.length && results.length < count)) {
            _context.n = 8;
            break;
          }
          _context.n = 6;
          return app.core.blockchain.getBlock(String(hashes[i]), false);
        case 6:
          block = _context.v;
          if (block) {
            results.push(blockHeaderToJson(block));
          }
        case 7:
          i++;
          _context.n = 5;
          break;
        case 8:
          _context.n = 11;
          break;
        case 9:
          _context.n = 10;
          return app.core.blockchain.getBlock(BigInt(id), false);
        case 10:
          _block = _context.v;
          if (_block) {
            results.push(blockHeaderToJson(_block));
          }
        case 11:
          _context.n = 13;
          break;
        case 12:
          _context.p = 12;
          _t = _context.v;
          return _context.a(3, 14);
        case 13:
          id--;
          _context.n = 2;
          break;
        case 14:
          return _context.a(2, success(results));
        case 15:
          _context.n = 16;
          return app.core.blockchain.getBlocks(count, includeOffchain);
        case 16:
          blocks = _context.v;
          return _context.a(2, success(blocks.map(function (block) {
            return blockHeaderToJson(block);
          })));
      }
    }, _callee, null, [[3, 12]]);
  }));
  return _handleRequestBlocks.apply(this, arguments);
}
function handleRequestBlock(_x3, _x4) {
  return _handleRequestBlock.apply(this, arguments);
} // Number of recent longest-chain blocks sampled for the dashboard's rolling
// statistics (Golden Ticket coverage in particular). This is a rolling window,
// so coverage is an estimate over the most recent blocks rather than the chain.
function _handleRequestBlock() {
  _handleRequestBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, txmsg) {
    var _params$include_trans;
    var params, includeTransactions, identifier, block;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          params = requestParams(txmsg);
          includeTransactions = Boolean((_params$include_trans = params.include_transactions) !== null && _params$include_trans !== void 0 ? _params$include_trans : false);
          identifier = null;
          if (!(params.hash !== undefined && params.hash !== null && params.hash !== '')) {
            _context2.n = 1;
            break;
          }
          identifier = String(params.hash);
          _context2.n = 3;
          break;
        case 1:
          if (!(params.block_id !== undefined && params.block_id !== null && params.block_id !== '')) {
            _context2.n = 2;
            break;
          }
          identifier = BigInt(params.block_id);
          _context2.n = 3;
          break;
        case 2:
          return _context2.a(2, failure('hash or block_id required'));
        case 3:
          _context2.n = 4;
          return app.core.blockchain.getBlock(identifier, includeTransactions);
        case 4:
          block = _context2.v;
          if (block) {
            _context2.n = 5;
            break;
          }
          return _context2.a(2, failure('block not found'));
        case 5:
          if (!includeTransactions) {
            _context2.n = 6;
            break;
          }
          return _context2.a(2, success(blockToJson(block)));
        case 6:
          return _context2.a(2, success(blockHeaderToJson(block)));
      }
    }, _callee2);
  }));
  return _handleRequestBlock.apply(this, arguments);
}
var INFO_BLOCK_WINDOW = 20;
function bigIntToNumber(value) {
  try {
    return value == null ? null : Number(value);
  } catch (err) {
    return null;
  }
}
function bigIntToString(value) {
  try {
    return value == null ? null : value.toString();
  } catch (err) {
    return null;
  }
}

// Returns a summary of the serving node's blockchain for the explorer dashboard.
// Chain-level values (latest/genesis block ids) and per-block consensus values
// (burn fee, difficulty, fees) are read directly from this full node, so they
// are exact for the node answering the request.
function handleRequestInfo(_x5) {
  return _handleRequestInfo.apply(this, arguments);
}
function _handleRequestInfo() {
  _handleRequestInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
    var blocks, genesisBlockId, latest, goldenTicketCount, i, _blocks$i, readBlockNumber, readBlockString, _t2, _t3, _t4;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          blocks = [];
          _context3.p = 1;
          _context3.n = 2;
          return app.core.blockchain.getBlocks(INFO_BLOCK_WINDOW, false);
        case 2:
          blocks = _context3.v;
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t2 = _context3.v;
          blocks = [];
        case 4:
          if (!Array.isArray(blocks)) {
            blocks = [];
          }
          genesisBlockId = null;
          _context3.p = 5;
          _t3 = bigIntToNumber;
          _context3.n = 6;
          return app.core.blockchain.get_genesis_block_id();
        case 6:
          genesisBlockId = _t3(_context3.v);
          _context3.n = 8;
          break;
        case 7:
          _context3.p = 7;
          _t4 = _context3.v;
          genesisBlockId = null;
        case 8:
          latest = blocks.length ? blocks[0] : null;
          goldenTicketCount = 0;
          for (i = 0; i < blocks.length; i++) {
            try {
              if ((_blocks$i = blocks[i]) !== null && _blocks$i !== void 0 && _blocks$i.hasGoldenTicket) {
                goldenTicketCount++;
              }
            } catch (err) {
              // ignore blocks that cannot report golden-ticket state
            }
          }
          readBlockNumber = function readBlockNumber(getter) {
            if (!latest) {
              return null;
            }
            try {
              return bigIntToNumber(latest[getter]);
            } catch (err) {
              return null;
            }
          };
          readBlockString = function readBlockString(getter) {
            if (!latest) {
              return null;
            }
            try {
              return bigIntToString(latest[getter]);
            } catch (err) {
              return null;
            }
          };
          return _context3.a(2, success({
            latest_block_id: readBlockNumber('id'),
            genesis_block_id: genesisBlockId,
            burnfee: readBlockString('burnFee'),
            difficulty: readBlockNumber('difficulty'),
            fees_last_block: readBlockString('totalFees'),
            atr_fees_last_block: readBlockString('totalFeesAtr'),
            golden_ticket_window: blocks.length,
            golden_ticket_count: goldenTicketCount
          }));
      }
    }, _callee3, null, [[5, 7], [1, 3]]);
  }));
  return _handleRequestInfo.apply(this, arguments);
}
function findTransactionInMempool(_x6) {
  return _findTransactionInMempool.apply(this, arguments);
}
function _findTransactionInMempool() {
  _findTransactionInMempool = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(transactionHash) {
    var mempoolTxs, i, txjson;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return Saito.getInstance().getMempoolTxs();
        case 1:
          mempoolTxs = _context4.v;
          i = 0;
        case 2:
          if (!(i < mempoolTxs.length)) {
            _context4.n = 4;
            break;
          }
          txjson = mempoolTxs[i];
          if (!((txjson === null || txjson === void 0 ? void 0 : txjson.signature) === transactionHash)) {
            _context4.n = 3;
            break;
          }
          return _context4.a(2, txjson);
        case 3:
          i++;
          _context4.n = 2;
          break;
        case 4:
          return _context4.a(2, null);
      }
    }, _callee4);
  }));
  return _findTransactionInMempool.apply(this, arguments);
}
function handleRequestTransaction(_x7, _x8) {
  return _handleRequestTransaction.apply(this, arguments);
}
function _handleRequestTransaction() {
  _handleRequestTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, txmsg) {
    var params, transactionHash, mempoolTx;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          params = requestParams(txmsg);
          transactionHash = params.transaction_hash || params.hash || params.signature;
          if (transactionHash) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2, failure('transaction_hash required'));
        case 1:
          _context5.n = 2;
          return findTransactionInMempool(String(transactionHash));
        case 2:
          mempoolTx = _context5.v;
          if (!mempoolTx) {
            _context5.n = 3;
            break;
          }
          return _context5.a(2, success(mempoolTx));
        case 3:
          return _context5.a(2, failure('transaction not found'));
      }
    }, _callee5);
  }));
  return _handleRequestTransaction.apply(this, arguments);
}
function handleExplorerRequest(_x9, _x0) {
  return _handleExplorerRequest.apply(this, arguments);
}
function _handleExplorerRequest() {
  _handleExplorerRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, txmsg) {
    var mod,
      _args6 = arguments,
      _t5;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          mod = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
          if (txmsg !== null && txmsg !== void 0 && txmsg.request) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, null);
        case 1:
          _t5 = txmsg.request;
          _context6.n = _t5 === 'request blocks' ? 2 : _t5 === 'request block' ? 3 : _t5 === 'request info' ? 4 : _t5 === 'request transaction' ? 5 : _t5 === 'request supply' ? 6 : _t5 === 'request address' ? 7 : 8;
          break;
        case 2:
          return _context6.a(2, handleRequestBlocks(app, txmsg));
        case 3:
          return _context6.a(2, handleRequestBlock(app, txmsg));
        case 4:
          return _context6.a(2, handleRequestInfo(app));
        case 5:
          return _context6.a(2, handleRequestTransaction(app, txmsg));
        case 6:
          return _context6.a(2, handleRequestSupply(app, mod, txmsg));
        case 7:
          return _context6.a(2, handleRequestAddress(app, mod, txmsg));
        case 8:
          return _context6.a(2, null);
        case 9:
          return _context6.a(2);
      }
    }, _callee6);
  }));
  return _handleExplorerRequest.apply(this, arguments);
}
module.exports = {
  handleExplorerRequest: handleExplorerRequest,
  requestParams: requestParams,
  success: success,
  failure: failure,
  blockToJson: blockToJson,
  blockHeaderToJson: blockHeaderToJson
};